import { del, get, post } from './index';

const localMode = process.env.REACT_APP_LOCAL_MODE === 'true';

const enrich = employees => {
  employees.forEach(employee => {
    employee.fullName = `${employee.firstName} ${employee.lastName}`;
  });

  return employees;
}

export const getEmployees = async () => {
  let employees = [];

  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(enrich(require('./mock-data/employees.json')));
      }, 200);
    });
  } else {
    employees = await get(`/employees`);
  }

  return enrich(employees);
};

export const onboardEmployee = async (employee) => {
  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200
        });
      }, 1000);
    });
  }

  return await post(`/employee_sync`, {
    email: employee.email
  });
};

export const onboardAllOutdated = async () => {
  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200
        });
      }, 1000);
    });
  }

  return await post(`/employee_sync_all`);
};

export const removeEmployee = async (employee) => {
  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200
        });
      }, 1000);
    });
  }

  return await del(`/remove_employee`, {
    email: employee.email
  });
};

export const getEmployeeManageData = async () => {
  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(require('./mock-data/employee_manage_data.json'));
      }, 200);
    });
  }

  return await get(`/employee_manage_data`);
};

/**
 * Unified create/update endpoint.
 * Differentiator: payload includes `id` for an update, omits `id` (or passes null) for a create.
 */
export const upsertEmployee = async (employee) => {
  const isUpdate = employee.id != null;

  if (localMode) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ status: 200 });
      }, 1000);
    });
  }

  const payload = {
    ...(isUpdate && { id: employee.id }),
    effectiveDate: employee.effectiveDate,
    firstName: employee.firstName,
    lastName: employee.lastName,
    email: employee.email,
    title: employee.title,
    level: employee.level,
    practiceName: employee.practiceName,
    capability: employee.capability,
    locationName: employee.locationName,
    employment_status: employee.employment_status,
    contractorRate: employee.contractorRate != null && employee.contractorRate !== "" ? parseFloat(employee.contractorRate) : null,
    managerId: employee.managerId || null,
    careerCoachId: employee.careerCoachId || null,
    startDate: employee.startDate,
    termDate: employee.termDate,
    ptoPolicy: employee.ptoPolicy || null,
    ptoModifier: employee.ptoModifier === "" || employee.ptoModifier == null ? null : parseFloat(employee.ptoModifier),
    ptoHoursOverride: employee.ptoHoursOverride === "" || employee.ptoHoursOverride == null ? null : parseFloat(employee.ptoHoursOverride),
    psaInstances: employee.psaInstances,
    primaryPsaInstance: employee.primaryPsaInstance
  };

  return await post(`/edit_employee`, payload, false);
};

